import { render, staticRenderFns } from "./PriorityPanel.vue?vue&type=template&id=024db8f7&scoped=true"
import script from "./PriorityPanel.vue?vue&type=script&lang=js"
export * from "./PriorityPanel.vue?vue&type=script&lang=js"
import style0 from "./PriorityPanel.vue?vue&type=style&index=0&id=024db8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024db8f7",
  null
  
)

export default component.exports